import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from "react-router-dom";

import VodTeaser from './VodTeaser';
import LiveTeaser from './LiveTeaser';
import GeniallyIframeView from './GeniallyIframeView';

const TeaserPage = () => {

    let { id, type } = useParams();
    const [searchParams] = useSearchParams();
    const specialRegister = searchParams.get('specialRegister');
    const [teaserType, setTeaserType] = useState(''); 

    useEffect(() => {
        if (specialRegister) {
            document.body.classList.add('theme-special-category');
        } else {
            document.body.classList.remove('theme-special-category');
        }
        return () => {
            document.body.classList.remove('theme-special-category');
        };
    }, [specialRegister]);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (type === 'vod') {
            setTeaserType('vod');
        }
        if (type === 'live') {
            setTeaserType('live');
        }
    }, [id, type]);

    if (id === '8f6ab1d4fc4646d3b2c6bbb2642ff753') {
        return <GeniallyIframeView />;
    }

    const TeaserBody = ({teaserType}) => {
        switch (teaserType) {
            case 'vod':
                return <VodTeaser id={id} />  
            case 'live':
                return <LiveTeaser id={id} />  
            default:
                return 'null';
        }
    }

    return (
        <section className="gen-section-padding-3 gen-single-movie">
            <div className="container">
                <div className="row no-gutters">
                    <div className="col-lg-12">
                        <div className="gen-single-movie-wrapper style-1">
                            <TeaserBody teaserType={teaserType} />
                        </div>
                    </div>
                </div>
            </div>
        </section>        
    )
}

export default TeaserPage;